<template>
  <!-- Main -->
  <div id="main" v-if="initialized">
    <!-- 電子發票 -->
    <div id="mainInvoice">
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item">
              <span class="title">電子發票</span>
              <a class="setting main" @click="popInvoice()" v-if="!isShowByLoadInData"
                ><FontAwesomeIcon icon="cog"
              /></a>
              <label class="switch" v-if="isShowByLoadInData" >
                <input type="checkbox" v-model="switchValue" @change="invoiceSwitch"/>
                <span class="slider round"></span>
              </label>
            </div>
            <table class="content fit empty" v-if="isShowByLoadInData">
              <EditBoxInputTableStyle
                :name="'特店名稱'"
                v-model="invoice.appointedStoreName"
                :customizeStyle="{ input: true, fake: true }"
              />
              <EditBoxInputTableStyle
                :name="'發票抬頭'"
                v-model="invoice.title"
                :customizeStyle="{ input: true }"
                @update-input="updateInvoiceTitle()"
                @change-edit-status="changeEditStatus($event)"
              />
              <EditBoxInputTableStyle
                :name="'統一編號'"
                v-model="invoice.number"
                :customizeStyle="{ input: true, fake: true }"
              />
              <EditBoxInputTableStyle
                :name="'本期剩餘票號組數'"
                v-model="invoice.numOfSet"
                :customizeStyle="{ input: true, fake: true }"
              />
              <EditBoxInputTableStyle
                :name="'出單機序號'"
                v-model="invoice.printerSn"
                :customizeStyle="{ input: true }"
                @update-input="updateInvoicePrinterParams()"
                @change-edit-status="changeEditStatus($event)"
              />
              <EditBoxInputTableStyle
                id="printer-did-input"
                :name="'出單機Device ID'"
                v-model="invoice.printerDid"
                :customizeStyle="{ input: true }"
                @update-input="updateInvoicePrinterParams()"
                @change-edit-status="changeEditStatus($event)"
              />
            </table>
            <div class="item justify-content-end">
              <el-button type="primary" round size="small"
                @click="manualFetch(10)">
                取號10組
              </el-button>
              <el-popconfirm
                title="確定清除此店家的發票串接設定？此操作不可恢復。"
                confirm-button-text="確定清除"
                cancel-button-text="取消"
                @onConfirm="handleClearInvoiceSettings()">
                <el-button slot="reference" type="danger" round size="small">
                  清除發票串接設定
                </el-button>
              </el-popconfirm>
              <el-popconfirm
                title="確定清除此店家的當期預取字軌？僅刪除未使用的字軌。"
                confirm-button-text="確定清除"
                cancel-button-text="取消"
                @onConfirm="handleClearInvoiceTracks()">
                <el-button slot="reference" type="danger" round size="small">
                  清除當期字軌
                </el-button>
              </el-popconfirm>
            </div>
          </div>
        </div>
      </div>

      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <span class="title">是否自動開立發票</span>
            <div class="flexH width">
              <div class="flexH width margin padding height background">
                <label class="switch">
                  <input type="checkbox" v-model="data.is_qc_invoice" @change="autoInvoiceSwitch('is_qc_invoice', data.is_qc_invoice)"/>
                  <span class="slider round"></span>
                </label>
                <div class="flexH width middle">
                  <div class="img"><img src="@/assets/img/gaa-other/QC.png"></div>
                </div>
              </div>
              <div class="flexH width margin padding height background">
                <label class="switch">
                  <input type="checkbox" v-model="data.is_qp_invoice" @change="autoInvoiceSwitch('is_qp_invoice', data.is_qp_invoice)"/>
                  <span class="slider round"></span>
                </label>
                <div class="flexH width middle">
                  <div class="img"><img src="@/assets/img/gaa-other/QP.png"></div>
                </div>
              </div>
              <div class="flexH width margin padding background disabled"> <!-- class: disabled -->
                <label class="switch">
                  <input type="checkbox" v-model="data.is_co_invoice" @change="autoInvoiceSwitch('is_co_invoice', data.is_co_invoice)"/>
                  <span class="slider round"></span>
                </label>
                <div class="flexH width middle">
                  <div class="img"><img src="@/assets/img/gaa-other/Doo.png"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item">
              <span class="title">自動取號</span>
              <label class="switch">
                <input type="checkbox" checked />
                <span class="slider round"></span>
              </label>
            </div>
            <div class="item">
              <span class="content">當少於</span>
              <div class="number">
                <input type="number" value="100" min="0" />
                <span class="content unit">組</span>
              </div>
              <span class="content">自動取號</span>
              <div class="number">
                <input type="number" value="100" min="0" />
                <span class="content unit">組</span>
              </div>
            </div>
          </div>
        </div>
        <div class="areaV">
          <div class="box">
            <span class="title">立即取號</span>
            <div class="number">
              <input type="number" value="100" min="0" />
              <span class="content unit">組</span>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Popup (Invoice) -->
      <section id="popInvoice" class="popInvoice popup notice">
        <div class="popBody">
          <a class="close"><FontAwesomeIcon icon="times"/></a>
          <section class="popHeader">
            <span class="title">電子發票申請</span>
          </section>
          <section class="popMain">
            <table class="content empty">
              <EditBoxInputTableStyle
                :name="'特店名稱'"
                v-model="applyInvoice.appointedStoreName"
                :customizeStyle="{ input: true }"
                form
                v-validate="validations['特店名稱']"
              ><span class="remark red">{{ errors.first('特店名稱') }}</span></EditBoxInputTableStyle>
              <EditBoxInputTableStyle
                :name="'特店發票抬頭'"
                :remark="'建議最多8個中文字將印於紙本發票上方'"
                v-model="applyInvoice.title"
                :customizeStyle="{ input: true }"
                form
                v-validate="validations['特店發票抬頭']"
              ><span class="remark red">{{ errors.first('特店發票抬頭') }}</span></EditBoxInputTableStyle>
              <EditBoxInputTableStyle
                :name="'特店地址'"
                v-model="applyInvoice.address"
                :customizeStyle="{ input: true }"
                form
                v-validate="validations['特店地址']"
              ><span class="remark red">{{ errors.first('特店地址') }}</span></EditBoxInputTableStyle>
              <EditBoxInputTableStyle
                :name="'特店ID'"
                :remark="'6碼，需與頭家網所申請一致'"
                v-model="applyInvoice.sellerId"
                :customizeStyle="{ input: true }"
                form
                v-validate="validations['特店ID']"
              ><span class="remark red">{{ errors.first('特店ID') }}</span></EditBoxInputTableStyle>
              <EditBoxInputTableStyle
                :name="'裝置ID'"
                :remark="'需與頭家網所申請一致'"
                v-model="applyInvoice.deviceId"
                :customizeStyle="{ input: true }"
                form
                v-validate="validations['裝置ID']"
              ><span class="remark red">{{ errors.first('裝置ID') }}</span></EditBoxInputTableStyle>
              <EditBoxInputTableStyle
                :name="'EDC ID'"
                :remark="'需與頭家網所申請一致'"
                v-model="applyInvoice.edcId"
                :customizeStyle="{ input: true }"
                form
                v-validate="validations['EDC ID']"
              ><span class="remark red">{{ errors.first('EDC ID') }}</span></EditBoxInputTableStyle>
              <EditBoxInputTableStyle
                :name="'統一編號'"
                :remark="'8碼數字，需與頭家網所申請一致'"
                v-model="applyInvoice.number"
                :customizeStyle="{ input: true }"
                form
                v-validate="validations['統一編號']"
              ><span class="remark red">{{ errors.first('統一編號') }}</span></EditBoxInputTableStyle>
              <EditBoxInputTableStyle
                :name="'使用者名稱'"
                :remark="'登入頭家網後台之使用者名稱'"
                v-model="applyInvoice.user"
                :customizeStyle="{ input: true }"
                form
                v-validate="validations['使用者名稱']"
              ><span class="remark red">{{ errors.first('使用者名稱') }}</span></EditBoxInputTableStyle>
              <EditBoxInputTableStyle
                :name="'使用者密碼'"
                :remark="'登入頭家網後台之使用者密碼'"
                v-model="applyInvoice.password"
                :customizeStyle="{ input: true }"
                form
                v-validate="validations['使用者密碼']"
              ><span class="remark red">{{ errors.first('使用者密碼') }}</span></EditBoxInputTableStyle>
              
              <!-- printer -->
              <tr>
                <td><span>出單機名稱</span></td>
                <td>
                  <div class="dropdown full">
                    <select v-model="applyInvoice.printer">
                      <option v-for="option of printerOptions" :key="option.did" :value="option">{{ option.name }}</option>
                    </select>
                    <div class="arrow"><FontAwesomeIcon icon="caret-down" /></div>
                  </div>
                </td>
              </tr>
              <tr>
                <td><span>出單機序號</span></td>
                <td><div class="flexV">
                  <input class="input fake" type="text" :value="applyInvoice.printer.sn">
                </div></td>
              </tr>
              <tr>
                <td><span>出單機Device ID</span></td>
                <td><div class="flexV">
                  <input class="input fake" type="text" :value="applyInvoice.printer.did">
                </div></td>
              </tr>
            </table>
          </section>
          <section class="popFooter">
            <a class="button cancel white"><span class="remark">取消</span></a>
            <a class="button submit" @click.prevent="onSubmit"><span class="remark">送出申請</span></a>
          </section>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import EditBoxInput from "src/components/GaaConsole/EditBoxInput.vue";
import EditBoxInputTableStyle from "src/components/GaaConsole/EditBoxInputTableStyle.vue";
import EditBoxSelect from "src/components/GaaConsole/EditBoxSelect.vue";
import {
  updateAccounts,
  updateBusiness,
  updateBusinessInfo,
  updateAccountSSo
} from "src/javascripts/generalPages/updateForConsoleLog";
import { fetchSettings } from "src/javascripts/generalPages/fetchForConsoleLog";
import { getInvoiceSetting, fetchPrintersUnderShop } from "src/javascripts/gaa/fetchData";
import { invoiceSwitch, createInvoice, fetchInvoices } from "src/javascripts/gaa/postData";
import { updateInvoiceTitle, updateInvoicePrinterParams } from "src/javascripts/gaa/updateData";
import { clearInvoiceSettings, clearInvoiceTracks } from "src/javascripts/gaa/deleteData";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { Validator } from "vee-validate";


let instance = new Validator();
instance.extend('invoiceFormat', (value) => {
  let patt = new RegExp(/^\d{8}$/);
  return patt.test(value);
});
instance.extend('stringLengthFormat', (value) => {
  return value.length > 0 && value.length < 9;
});
instance.extend('sellerIdFormat', (value) => {
  let patt = new RegExp(/^\w{6}$/);
  return patt.test(value);
});
instance.extend('uuidFormat', (value) => {
  let patt = new RegExp(/\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/);
  return patt.test(value);
});
instance.extend('snFormat', (value) => {
  let patt = new RegExp(/^\d{9}$/);
  return patt.test(value);
});

instance.attach({
  name: 'invoiceField',
  rules: 'invoiceFormat'
});
instance.attach({
  name: 'appointedStoreNameField',
  rules: 'stringLengthFormat'
});
instance.attach({
  name: 'sellerIdField',
  rules: 'sellerIdFormat'
});
instance.attach({
  name: 'uuidField',
  rules: 'uuidFormat'
});
instance.attach({
  name: 'snField',
  rules: 'snFormat'
});

var dict = {
  custom: {
    '特店名稱': {
      required: "必填",
    },
    '特店發票抬頭': {
      required: "必填",
      stringLengthFormat: "請輸入最多8個字"
    },
    '特店地址': {
      required: "必填"
    },
    '特店ID': {
      required: "必填",
      sellerIdFormat: "格式錯誤，請輸入6位英數"
    },
    '裝置ID': {
      required: "必填"
    },
    'EDC ID': {
      required: "必填"
    },
    '統一編號': {
      required: "必填",
      invoiceFormat: "格式錯誤，請輸入8位數字"
    },
    '使用者名稱': {
      required: "必填"
    },
    '使用者密碼': {
      required: "必填"
    },
    '出單機序號': {
      required: "必填",
      snFormat: "格式錯誤，請輸入9位數字"
    },
    '出單機Device ID': {
      required: "必填",
      uuidFormat: "格式錯誤"
    }
  }
};

Validator.localize("en", dict);

export default {
  components: {
    EditBoxInput,
    EditBoxInputTableStyle,
    EditBoxSelect,
    FontAwesomeIcon
  },
  data() {
    return {
      data: {
        is_qc_invoice: false,
        is_qp_invoice: false,
        is_co_invoice: false,
      },
      invoice: {
        // status: "使用中",
        // appointedStoreName: "特店名稱",
        // title: "發票抬頭",
        // number: "87654321",
        // numOfSet: 108,
        // printerSn: '',
        // printerDid: ''
      },
      applyInvoice: {
        appointedStoreName: "",
        title: "",
        address: "",
        sellerId: "",
        deviceId: "",
        edcId: "",
        number: "",
        user: "",
        password: "",
        printer: {
          name: "",
          sn: "",
          did: ""
        },
      },
      initialized: true,
      editList: [],
      switchValue: false,
      validations: {
        '特店名稱': {
          required: true
        },
        '特店發票抬頭': {
          required: true,
          stringLengthFormat: true
        },
        '特店地址': {
          required: true
        },
        '特店ID': {
          required: true,
          sellerIdFormat: true
        },
        '裝置ID': {
          required: true
        },
        'EDC ID': {
          required: true
        },
        '統一編號': {
          required: true,
          invoiceFormat: true
        },
        '使用者名稱': {
          required: true
        },
        '使用者密碼': {
          required: true
        },
        '出單機序號': {
          required: true,
          snFormat: true
        },
        '出單機Device ID': {
          required: true,
          uuidFormat: true
        }
      },
      printerOptions: [
        {
          name: '----空----',
          sn: null,
          did: null
        }
      ]
    };
  },
  props: {
    accountId: {
      type: Number,
      default: 1
    },
    shopId: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    }
  },
  created() {
    fetchSettings(this.accountId, this.$route.params.type)
      .then(res => {
        let fetchSettingsRes = res;
        if (fetchSettingsRes.data.length > 0) {
          var settingData = {};
          Object.assign(settingData, fetchSettingsRes.data[0]);
          this.setData(settingData);
          return this.getPrinterSnOption();
        } else {
          throw new Error("FetchData error!");
        }
      })
      .catch(err => {
        console.log("err: ", err);
        this.$message({
          type: "error",
          message: `商店：${this.accountId} ，無法取得資料！`
        });
      });
  },
  mounted() {
    console.log("mounted!!");
    this.getInvoiceSetting();
  },
  computed: {
    type() {
      return this.$route.params.type || 'gaa';
    },
    isShowByLoadInData() {
      return Object.keys(this.invoice).length > 0;
    }
  },
  methods: {
    getInvoiceSetting() {
      getInvoiceSetting(this.accountId)
      .then(res => {
        console.log("getInvoiceSetting res: ", res);
        let data = res.data;
        let invoiceData = data.invoiceData;
        this.invoice = this.deepUpdateObject(this.invoice, {
          sellerId: invoiceData.id,
          appointedStoreName: invoiceData.name,
          title: invoiceData.shortName,
          number: invoiceData.sellerTaxId,
          numOfSet: invoiceData.count,
          printerSn: invoiceData.printerSn,
          printerDid: invoiceData.printerDid
        });
        this.switchValue = data.isInvoiceEnable;
        console.log("this.switchValue: ", this.switchValue)
        if(Object.keys(this.invoice).length == 0) {
          this.popInvoice();
        }
      })
      .catch(err => {
        console.log("getInvoiceSetting err: ", err);
      });
    },
    getPrinterSnOption() {
      const data = { shopId: this.shopId };
      return fetchPrintersUnderShop(this.accountId, data)
      .then(res => {
        let fetchPrintersUnderShopRes = res.data;
        this.printerOptions = [{
          name: '----空----',
          sn: null,
          did: null,
        }];
        fetchPrintersUnderShopRes.forEach(option => {
         this.printerOptions.push({
            name: option.name,
            sn: option.sn,
            did: option.did
          });
        })
      })
      .catch(err => {
        console.log("getPrinterSnOption err: ", err);
      })
    },
    onSubmit () {
      var that = this;
      this.$validator.validate().then(valid => {
        console.log("valid: ", valid);
        if (valid) {
          this.popInvoiceClose();
          this.createInvoice()
          .then(res => {
            that.$message({
              type: 'success', message: '開通成功'
            });
            return that.getPrinterSnOption()
              .then(res => that.getInvoiceSetting());
          })
          .catch(err => {
            console.log("onSubmit: ", err);
            that.$message({
              type: 'error', message: '開通失敗'
            });
          });
        }
      });
    },
    createInvoice() {
      // call API
      console.log("this.applyInvoice: ", this.applyInvoice);

      let dataForlog = {
        key: "einvioice_setting",
        value: this.applyInvoice,
        label: "電子發票設定",
        dbTable: "invoice",
        type: "content"
      }
      let createInvoiceData = Object.assign({}, {
        "name": this.applyInvoice.appointedStoreName,
        "shortName": this.applyInvoice.title,
        "address": this.applyInvoice.address,
        "sellerId": this.applyInvoice.sellerId,
        "deviceId": this.applyInvoice.deviceId,
        "edcId": this.applyInvoice.edcId,
        "sellerTaxId": this.applyInvoice.number,
        "userId": this.applyInvoice.user,
        "passwd": this.applyInvoice.password,
        "printerSn": this.applyInvoice.printer.sn,
        "printerDid": this.applyInvoice.printer.did,
      }, dataForlog);
      console.log("createInvoiceData: ", createInvoiceData);
      return createInvoice(this.accountId, createInvoiceData)
      .then(res => {
        console.log("createInvoice res: ", res);

        return fetchInvoices(this.accountId, {
          "sellerId": this.applyInvoice.sellerId,
          "count": 30 //FIXME: 預取號30組
        });
        // return res;
      })
      .then(res => {
        console.log("createInvoice-fetckInvoice res: ", res);
        return res;
      })
      .catch(err => {
        console.log("createInvoice err: ", err);
        throw err;
      });
    },
    manualFetch(count = 1) {
      fetchInvoices(this.accountId, {
        "sellerId": this.invoice.sellerId,
        "count": count
      })
      .then(res => {
        console.log(`manualFetch (count = ${count}) response`, res);
      })
      .catch(err => {
        console.error(`manualFetch (count = ${count}) failed`, err);
        throw err;
      });
    },
    handleClearInvoiceSettings() {
      clearInvoiceSettings(this.accountId)
      .then(res => {
        console.log("clearInvoiceSettings res: ", res);
        this.$message({ type: 'success', message: '發票串接設定已清除' });
      })
      .catch(err => {
        console.error("clearInvoiceSettings err: ", err);
        this.$message({ type: 'error', message: '清除發票串接設定失敗：' + ((err.response && err.response.data && err.response.data.message) || err.message) });
      });
    },
    handleClearInvoiceTracks() {
      clearInvoiceTracks(this.accountId)
      .then(res => {
        console.log("clearInvoiceTracks res: ", res);
        let data = res.data || {};
        this.$message({ type: 'success', message: `已清除當期字軌（${data.ym || ''}），共刪除 ${data.deleted || 0} 筆` });
      })
      .catch(err => {
        console.error("clearInvoiceTracks err: ", err);
        this.$message({ type: 'error', message: '清除當期字軌失敗：' + ((err.response && err.response.data && err.response.data.message) || err.message) });
      });
    },
    updateInvoiceTitle() {
      // call API
      console.log("updateInvoiceTitle");
      let updateInvoiceTitleData = {
        shortName: this.invoice.title
      };
      let dataForlog = {
        key: "einvioice_setting",
        value: this.invoice.title,
        label: "電子發票抬頭",
        dbTable: "invoice_title",
        type: "string"
      }
      Object.assign(updateInvoiceTitleData, dataForlog);
      console.log("updateInvoiceTitleData: ", updateInvoiceTitleData)
      var that = this;
      updateInvoiceTitle(this.accountId, updateInvoiceTitleData)
      .then(res => {
        console.log("updateInvoiceTitle res: ", res);
        that.$message({
          type: 'success', message: '修改成功'
        });
      })
      .catch(err => {
        console.log("updateInvoiceTitle err: ", err);
        that.$message({
          type: 'error', message: '修改失敗'
        });
      });
    },
    updateInvoicePrinterParams() {
      console.log("updateInvoicePrinterParams");
      let updateInvoicePrinterParamsData = {
        printerSn: this.invoice.printerSn,
        printerDeviceId: this.invoice.printerDid
      };
      let dataForlog = {
        key: "einvioice_setting",
        value: this.invoice.printerSn + ':' + this.invoice.printerDid ,
        label: "電子發票出單機參數",
        dbTable: "invoice_printer",
        type: "string"
      }
      Object.assign(updateInvoicePrinterParamsData, dataForlog);
      console.log("updateInvoicePrinterParamsData: ", updateInvoicePrinterParamsData)
      var that = this;
      updateInvoicePrinterParams(
        this.accountId,
        updateInvoicePrinterParamsData
      )
      .then(res => {
        console.log("updateInvoicePrinterParams res: ", res);
        that.$message({
          type: 'success', message: '修改成功'
        });
      })
      .catch(err => {
        console.log("updateInvoicePrinterParams err: ", err);
        that.$message({
          type: 'error', message: '修改失敗'
        });
      });
    },
    invoiceSwitch() {
      // call API
      let invoiceSwitchData = {
        switchValue: this.switchValue
      };
      let dataForlog = {
        key: "einvioice_setting",
        value: this.switchValue,
        label: "電子發票開關",
        dbTable: "invoice_switch",
        type: "boolean"
      }
      Object.assign(invoiceSwitchData, dataForlog);
      var that = this;
      invoiceSwitch(this.accountId, invoiceSwitchData)
      .then(res => {
        console.log("callInvoiceSwitch res: ", res);
        that.$message({
          type: 'success', message: `修改成功(${this.switchValue ? '開啟' : '關閉'})`
        });
      })
      .catch(err => {
        console.log("callInvoiceSwitch err: ", err);
        that.$message({
          type: 'error', message: '修改失敗'
        });
      });
    },
    deepUpdateObject(obj, val) {
      return JSON.parse(JSON.stringify(Object.assign(obj, val)));
    },
    setData(fetchData) {
      for (var prop in fetchData) {
        if (fetchData[prop] === 1) fetchData[prop] = true;
        if (fetchData[prop] === 0) fetchData[prop] = false;
      }
      console.log("fetchData: ", fetchData);
      this.data = Object.assign(this.data, fetchData);
      console.log("this.data: ", this.data);
      this.initialized = true;
    },
    toggleSwitch(event) {
      this.data[event.code] = event.mutation;
      this.data = Object.assign(this.data);

      let updateBooleanData = {
        key: event.code,
        value: event.mutation,
        dbTable: event.dbTable,
        label: event.name,
        type: event.type
      };
      this.edit(updateBooleanData);
    },
    updateInput(event) {
      console.log("updateInput event: ", event);
      let updateInputData = {
        key: event.code,
        value: event.mutation,
        dbTable: event.dbTable,
        origin: event.origin,
        label: event.name,
        type: event.type
      };
      this.edit(updateInputData);
    },
    edit(data) {
      let label = data.label;
      if (data.key === "name") data.dbTable = "accounts&business";
      switch (data.dbTable) {
        case "accounts":
          updateAccounts(data, this.accountId, this.type)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "business":
          updateBusiness(data, this.accountId, this.type)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "business_info":
          updateBusinessInfo(data, this.accountId, this.type)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "accounts&business":
          updateAccounts(data, this.accountId, this.type)
            .then(res => updateBusiness(data, this.accountId, this.type))
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "account_sso":
          let fields = Object.assign(
            {},
            {
              name: this.data.name,
              accountId: this.accountId,
              appId: data.value
            }
          );
          Object.assign(data, {
            fields: fields
          });
          console.log("data: ", data);
          updateAccountSSo(data, this.accountId, this.type)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        default:
          console.log("undefined db talbe: " + data.dbTable);
          break;
      }
    },
    editSuccess(res, label) {
      console.log(res);
      this.$message({
        type: "success",
        message: `${label} 修改成功！`
      });
      this.$emit("saved", true);
    },
    editError(err) {
      console.log(err);
      this.$message({
        type: "error",
        message: "修改失敗"
      });
    },
    popInvoice() {
      var popInvoice = document.getElementById("popInvoice");
      var close = popInvoice.getElementsByClassName("close")[0];
      var submit = popInvoice.getElementsByClassName("submit")[0];
      var cancel = popInvoice.getElementsByClassName("cancel")[0];
      close.onclick = function() {
        popInvoice.style.display = "none";
      };
      cancel.onclick = function() {
        popInvoice.style.display = "none";
      };
      window.onclick = function(event) {
        if (event.target == popInvoice) {
          popInvoice.style.display = "none";
        }
      };
      popInvoice.style.display = "flex";
    },
    popInvoiceClose() {
      var popInvoice = document.getElementById("popInvoice");
      popInvoice.style.display = "none";
    },
    changeEditStatus(event) {
      let editDataIndex = this.editList.findIndex(d => d.code == event.code);
      if (event.warning) {
        if (editDataIndex == -1) {
          this.editList.push(event);
        } else {
          let editData = this.editList.find(d => d.code == event.code);
          Object.assign(editData, event);
        }
      } else {
        if (editDataIndex != -1) {
          this.editList.splice(editDataIndex, 1);
        }
      }
    },
    autoInvoiceSwitch(code, value) {
      console.log("event: ", event)
      this.data[event.code] = event.mutation;
      this.data = Object.assign(this.data);

      let name = "";
      switch (code) {
        case 'is_qc_invoice':
          name = "自動開立QC電子發票";
          break;
        case 'is_qp_invoice':
          name = "自動開立QP電子發票";
          break;
        case 'is_co_invoice':
          name = "自動開立iDoo電子發票";
          break;
        default:
          break;
      }

      let updateBooleanData = {
        key: code,
        value: value,
        dbTable: 'business',
        label: name,
        type: 'boolean'
      };
      this.edit(updateBooleanData);
    }
  },
  watch: {
    invoice: {
      deep: true,
      handler(val) {
        console.log("invoice: ", val);
      }
    }
  }
};
</script>
<style scoped src="../../../../../src/assets/css/shop-console.css"></style>
<style>
#printer-did-input input {
  min-width: 320px;
}
</style>
